import { createFileRoute } from "@tanstack/react-router";
import { IVRForm } from "@/routes/_dashboard/ivr/-components/ivr-form";

type SearchParams = {
  showInfo?: boolean;
};

export const Route = createFileRoute("/_dashboard/ivr/new-ivr")({
  component: CreateIVRComponent,
  validateSearch: (search: Record<string, unknown>): SearchParams => {
    return {
      showInfo: search.showInfo as boolean | undefined,
    };
  },
  loader: async () => {
    return {
      crumb: "New IVR",
    };
  },
});

function CreateIVRComponent() {
  return <IVRForm ivr={null} isEdit={false} />;
}
